import { useState } from "react";
import { prepareQuestionImageUrl } from "./common";
import styles from "./questionImage.module.scss";
import { QuestionImageModal } from "./questionImageModal";

export const QuestionImage = (props: Props) => {
  const [showModal, setShowModal] = useState(false);

  function onModalClose() {
    setShowModal(false);
  }

  return (
    <>
      <div className={styles["questionImageWrapper"]}>
        <img
          src={prepareQuestionImageUrl(props.imageUrl, 512)}
          alt={props.imageAlt}
          onClick={() => setShowModal(true)}
        />
      </div>
      <QuestionImageModal
        imageUrl={props.imageUrl}
        imageAlt={props.imageAlt}
        visible={showModal}
        onClose={onModalClose}
      />
    </>
  );
};

interface Props {
  imageUrl: string;
  imageAlt?: string;
}
